// Auto cache buster — increment APP_VERSION every deployment
// This forces clients with stale caches to reload
const APP_VERSION = '1.0.3'
const VERSION_KEY = 'vs_app_version'

export function checkAndBustCache(): void {
  try {
    const stored = localStorage.getItem(VERSION_KEY)

    if (stored !== APP_VERSION) {
      console.log(`Version changed ${stored} → ${APP_VERSION}, clearing cache`)

      // 1. Clear all Cache API caches
      if ('caches' in window) {
        caches.keys().then(keys => Promise.all(keys.map(k => caches.delete(k))))
      }

      // 2. Unregister service workers
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(regs =>
          Promise.all(regs.map(r => r.unregister()))
        )
      }

      // 3. Clear sessionStorage (not localStorage — we need auth + theme)
      sessionStorage.clear()

      // 4. Store new version
      localStorage.setItem(VERSION_KEY, APP_VERSION)

      // 5. Hard reload to get fresh JS/CSS from Cloudflare
      // Only reload if this is not the first visit (stored !== null)
      if (stored !== null) {
        window.location.reload()
      }
    }
  } catch { /* best effort */ }
}